import http from '@/utils/http';

import type { IBaseResponse } from '@home/types/common';

/**
 * 获取Genre Profile页面列表数据、Market Profile页面列表数据
 * @param payload 参数 具体定义参见IGenreMarketProfileFetchParams的定义
 * @return Genre Profile页面列表数据、Market Profile页面列表数据
 */
export const fetchGenreMarketProfiles: (
  payload: IGenreMarketProfileFetchParams,
) => IBaseResponse<IGenreMarketProfileResponseData> = (payload) => {
  return http({
    url: '/api/v1/intelligence_pc/profile/market/metric_list',
    method: 'post',
    data: payload,
    rawData: true,
  }) as any;
};
